<template>

    <div class="black-list knowledge-base">
        <div class="black-list__heading knowledge-base__heading d-flex">
            <img src="/assets/images/blacklist.svg" />

            <div class="black-list__heading-title knowledge-base__heading-title">
                Черный список
            </div>
        </div>
        <div class="black-list__content">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">

                        <div class="black-list__content-wrap">

                            <div class="black-list__form-nav d-flex">
                                <button type="button" class="black-list__form-nav-button" :class="blackListCheck ? 'black-list__form-nav-button--active' : ''" @click.prevent="blackListCheck = true">Проверить</button>
                                <button type="button" class="black-list__form-nav-button" :class="!blackListCheck ? 'black-list__form-nav-button--active' : ''" @click.prevent="blackListCheck = false">Добавить</button>
                            </div>

                            <div class="black-list__form-wrap" v-if="!loading">

                                <form action="#" @submit.prevent="checkUser" class="black-list__form" v-if="blackListCheck">

                                    <fieldset class="black-list__fieldset">
                                        <legend class="black-list__fieldset-legend">Введите номер телефона для проверки</legend>

                                        <div class="black-list__fieldset-group black-list__fieldset-group--search">
                                            <label class="black-list__fieldset-label">Номер телефона</label>
                                            <input name="formTel" type="tel" class="input black-list__fieldset-input" maxlength="19" autocomplete="off"
                                                   v-mask="'+375 (##) ###-##-##'" placeholder="+375 (29) 111-11-11" v-model="$v.searchForm.phone.$model">
                                            <div class="field-error-text" v-if="$v.searchForm.phone.$error">Номер телефона неверный</div>

                                            <ul class="search" v-if="searchArray.length">
                                                <li v-if="$v.searchForm.phone.$error">
                                                    <div class="field-error-text">Номер телефона неверный</div>
                                                </li>

                                                <li class="search__item" v-for="(item, idx) in searchArray" :key="idx">
                                                    <template v-if="item.contacts.length > 1">
                                                        <span>Связанные номера:</span>
                                                    </template>
                                                    <span class="search__label" v-for="contact in item.contacts" @click.prevent="setPhone(contact.contact)">
                                                        {{contact.contact}}</span>
                                                </li>
                                            </ul>
                                            <ul class="search" v-if="!searchArray.length && searchForm.phone.length >= 8
                                                                        && searchForm.phone.replace(/(\++)|([(]|[)])|(-)|(\s)/g,'') !== selectedSearchPhone">
                                                <li v-if="$v.searchForm.phone.$error">
                                                    <div class="field-error-text">Номер телефона неверный</div>
                                                </li>
                                                <li>
                                                    <span>
                                                        Номер не найден
                                                    </span>
                                                </li>
                                            </ul>

                                        </div>

                                        <button type="submit" @click.prevent="searchFormSumbit" class="input black-list__form-submit">Проверить</button>

                                    </fieldset>

                                    <black-list-modal @modal-close="handleClose" v-if="checkedUser || checkedUser === false" :blockedUser="checkedUser"/>

                                </form>

                                <form action="#" @submit.prevent="addUser" class="black-list__form" v-if="!blackListCheck">

                                    <fieldset class="black-list__fieldset">
                                        <legend class="black-list__fieldset-legend">Добавить в черный список</legend>



                                        <div class="black-list__actions d-flex">
                                            <button class="btn black-list__actions-btn"
                                                    :disabled="addForm.contactsArray.length === 4"
                                                    @click.prevent="addForm.contactsArray.push({phone: '', checkPhoneBeforeSend: false,check: false,})">Добавить номер</button>
                                            <button class="btn black-list__actions-btn"
                                                    :disabled="addForm.contactsArray.length === 1" @click.prevent="addForm.contactsArray.pop()">Удалить номер</button>
                                        </div>




                                        <div v-for="(v, index) in $v.addForm.contactsArray.$each.$iter" class="black-list__fieldset-group">
                                            <label class="black-list__fieldset-label">Номер телефона</label>
                                            <input name="blockTel" type="tel" class="input black-list__fieldset-input" maxlength="19"
                                                   v-mask="'+375 (##) ###-##-##'" placeholder="+375 (29) 111-11-11" v-model="v.phone.$model">

                                            <div class="field-error-text" v-if="v.phone.$error">Номер телефона неверный</div>
                                            <div class="field-error-text" v-if="!v.checkPhoneBeforeSend.val">Этот контакт уже добавлен в черный список</div>

                                        </div>




                                        <div class="black-list__fieldset-group">
                                            <label class="black-list__fieldset-label">Комментарий</label>
                                            <textarea name="blockComment" class="input black-list__fieldset-text-area" placeholder="Введите текстовое описание" v-model="$v.addForm.description.$model"></textarea>
                                            <div class="field-error-text" v-if="$v.addForm.description.$error">Длина комментария должна быть не меньше 30 символов.</div>
                                        </div>

                                        <div class="black-list__fieldset-group">
                                            <label class="black-list__fieldset-label-file">
                                                <span class="black-list__fieldset-label-text">Прикрепить файл</span>
                                                <div class="black-list__fieldset-label-file-wrap">
                                                    <span class="black-list__fieldset-label-button">Выберите файл</span>
                                                    <input type="file" name="blockFile" ref="file" multiple accept=".png,.jpeg,.jpg,.gif" placeholder="Введите текстовое описание" @change="handleAddImage">
                                                </div>

                                            </label>
                                        </div>
                                        <div class="field-error-text" v-if="unauthorized">Для того чтобы добавить человека в черный список вы должны быть авторизированы.</div>

                                        <div class="field-error-text text-center" v-if="userAdded">Информация по ЧС на проверке и будет доступна после модерации</div>

                                        <button type="submit" @click.prevent="addUser" class="black-list__form-submit">Добавить</button>

                                    </fieldset>

                                </form>

                            </div>

                            <div class="black-list__form-wrap" v-else>

                                <div class="black-list__form-loader loading">
                                    <div class="LoaderBalls">
                                        <div class="LoaderBalls__item"></div>
                                        <div class="LoaderBalls__item"></div>
                                        <div class="LoaderBalls__item"></div>
                                    </div>
                                </div>

                            </div>


                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import BlackListModal from './BlackListModal';

import {mask} from 'vue-the-mask'
import {helpers, required, minLength, maxLength} from 'vuelidate/lib/validators';

const phoneValidator = helpers.regex('phone', /^\+375\s\((29|44|33|25)\)\s[1-9]{1}\d{2}-\d{2}-\d{2}$/g);

const len = helpers.len()

export default {
    components: {
        BlackListModal
    },
    directives: {mask},
    name: "BlackList",

    data() {
        return {

            blackList: {
                titleImage: '<svg width="866" height="114" viewBox="0 0 866 114" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.271484 112V2.51562H39.5986C53.6852 2.51562 64.388 5.09733 71.707 10.2607C79.0762 15.4242 82.7607 22.9186 82.7607 32.7441C82.7607 38.4089 81.4574 43.2464 78.8506 47.2568C76.2438 51.2673 72.4089 54.2249 67.3457 56.1299C73.0605 57.6338 77.4469 60.4411 80.5049 64.5518C83.5628 68.6624 85.0918 73.6755 85.0918 79.5908C85.0918 90.3187 81.6829 98.3896 74.8652 103.804C68.0977 109.168 58.0466 111.9 44.7119 112H0.271484ZM26.665 65.4541V91.6973H43.96C48.7223 91.6973 52.3818 90.6195 54.9385 88.4639C57.4951 86.2581 58.7734 83.1751 58.7734 79.2148C58.7734 70.0911 54.2367 65.5042 45.1631 65.4541H26.665ZM26.665 48.1592H40.4258C46.1908 48.1091 50.3014 47.0563 52.7578 45.001C55.2142 42.9456 56.4424 39.9128 56.4424 35.9023C56.4424 31.2904 55.1139 27.9818 52.457 25.9766C49.8001 23.9212 45.514 22.8936 39.5986 22.8936H26.665V48.1592Z" fill="#F0F5FD" fill-opacity="0.1"/><path d="M129.153 91.6973H175.098V112H102.76V2.51562H129.153V91.6973Z" fill="#F0F5FD" fill-opacity="0.1"/><path d="M252.997 91.5469H216.828L210.512 112H182.313L222.468 2.51562H247.282L287.737 112H259.389L252.997 91.5469ZM223.144 71.1689H246.681L234.875 33.1953L223.144 71.1689Z" fill="#F0F5FD" fill-opacity="0.1"/><path d="M385.789 74.9287C385.438 82.5485 383.383 89.291 379.623 95.1562C375.863 100.971 370.574 105.483 363.757 108.691C356.989 111.9 349.244 113.504 340.521 113.504C326.134 113.504 314.804 108.817 306.533 99.4424C298.261 90.068 294.126 76.8337 294.126 59.7393V54.3252C294.126 43.5973 295.981 34.223 299.69 26.2021C303.45 18.1312 308.839 11.915 315.857 7.55371C322.875 3.14225 330.996 0.936523 340.22 0.936523C353.505 0.936523 364.183 4.44564 372.254 11.4639C380.325 18.432 384.912 28.057 386.014 40.3389H359.696C359.496 33.6716 357.816 28.8841 354.658 25.9766C351.5 23.069 346.687 21.6152 340.22 21.6152C333.653 21.6152 328.841 24.0716 325.783 28.9844C322.725 33.8971 321.121 41.7425 320.97 52.5205V60.2656C320.97 71.946 322.424 80.2926 325.332 85.3057C328.289 90.3187 333.353 92.8252 340.521 92.8252C346.587 92.8252 351.224 91.3965 354.432 88.5391C357.641 85.6816 359.345 81.1449 359.546 74.9287H385.789Z" fill="#F0F5FD" fill-opacity="0.1"/><path d="M438.573 71.2441L427.745 83.125V112H401.351V2.51562H427.745V50.791L436.919 36.8799L460.53 2.51562H493.165L456.169 50.9414L493.165 112H461.883L438.573 71.2441Z" fill="#F0F5FD" fill-opacity="0.1"/><path d="M570.76 91.6973H616.705V112H544.367V2.51562H570.76V91.6973Z" fill="#F0F5FD" fill-opacity="0.1"/><path d="M659.037 112H632.718V2.51562H659.037V112Z" fill="#F0F5FD" fill-opacity="0.1"/><path d="M736.936 82.8994C736.936 79.0394 735.557 76.0316 732.8 73.876C730.093 71.7204 725.306 69.4896 718.438 67.1836C711.57 64.8776 705.955 62.6468 701.594 60.4912C687.407 53.5231 680.314 43.9482 680.314 31.7666C680.314 25.7008 682.068 20.362 685.578 15.75C689.137 11.0879 694.15 7.47852 700.617 4.92188C707.083 2.3151 714.352 1.01172 722.423 1.01172C730.294 1.01172 737.337 2.41536 743.553 5.22266C749.819 8.02995 754.682 12.0404 758.141 17.2539C761.6 22.4173 763.329 28.3327 763.329 35H737.011C737.011 30.5384 735.633 27.0794 732.875 24.623C730.168 22.1667 726.484 20.9385 721.822 20.9385C717.109 20.9385 713.375 21.9912 710.618 24.0967C707.911 26.152 706.557 28.7839 706.557 31.9922C706.557 34.7995 708.061 37.3561 711.069 39.6621C714.077 41.918 719.365 44.2741 726.935 46.7305C734.505 49.1367 740.721 51.7435 745.583 54.5508C757.414 61.3685 763.329 70.7679 763.329 82.749C763.329 92.3239 759.72 99.8434 752.501 105.308C745.283 110.772 735.382 113.504 722.799 113.504C713.926 113.504 705.88 111.925 698.661 108.767C691.493 105.558 686.079 101.197 682.419 95.6826C678.81 90.1182 677.005 83.7266 677.005 76.5078H703.474C703.474 82.373 704.978 86.7093 707.986 89.5166C711.044 92.2738 715.982 93.6523 722.799 93.6523C727.161 93.6523 730.594 92.7249 733.101 90.8701C735.658 88.9652 736.936 86.3083 736.936 82.8994Z" fill="#F0F5FD" fill-opacity="0.1"/><path d="M865.893 22.8936H833.032V112H806.639V22.8936H774.38V2.51562H865.893V22.8936Z" fill="#F0F5FD" fill-opacity="0.1"/></svg>',
                titleText: "Черный список",
            },

            unauthorized: false,
            userAdded: null,
            addForm: {
              contactsArray: [
                  {
                      phone: '',
                      checkPhoneBeforeSend: true,
                      check: false,
                  }
              ],
              description: null,
              images: [],
            },
            searchForm: {
                phone: '',
            },

            searchArray: [],
            selectedSearchPhone: '',

            previewImagesOnlyBase64: [],
            previewImages: [],
            images: [],

            checkedUser: null,
            loading: false,
            blackListCheck: false,
            blockedUser: [],


        }
    },

    mounted() {
        this.blackListCheck = true;
    },

    validations: {
        addForm: {
            contactsArray:{
                required,
                minLength: minLength(1),
                maxLength: maxLength(4),
                $each:{
                    phone: {
                        required,
                        phoneValidator
                    },
                    checkPhoneBeforeSend:{
                        required,
                        val: function (val){
                            return val
                        }
                    }
                }
            },

            description: {
                required,
                minLength: minLength(30)
            }
        },

        searchForm: {
            phone: {
                required,
                phoneValidator
            },
        }
    },

    watch: {
        'searchForm.phone': function(){
            let phone = this.searchForm.phone ? this.searchForm.phone.replace(/(\++)|([(]|[)])|(-)|(\s)/g,'') : ''

            if(phone.length < 8 || phone === this.selectedSearchPhone) {
                this.searchArray = []
                return
            }

            this.searchBlackList(phone)

        },

        'addForm.contactsArray': {
            handler() {
                // console.log(this.addForm.contactsArray)

                // console.log(this.$v)

            },
            deep: true
        },

        computedArray(newValue){
            return newValue
        },

        images() {
            let self = this;

            if(!self.images.length){
                self.noReloadPreview = true;
                self.previewImages = [];
                self.previewImagesOnlyBase64 = [];
                self.addForm.images = [];
                return
            }

            if (self.noReloadPreview) {
                self.noReloadPreview = false;
                return false
            }

            self.images.forEach(function (image) {
                if (typeof FileReader === "function") {
                    const reader = new FileReader();

                    reader.onload = event => {
                        if ($.inArray(event.target.result, self.previewImagesOnlyBase64) === -1) {
                            self.previewImages.push({
                                'base64': event.target.result,
                                'name': image.name,
                            });
                            self.previewImagesOnlyBase64.push(event.target.result);
                            self.addForm.images.push(image);
                        }
                    };

                    reader.readAsDataURL(image);
                }
            });
        },
        blackListCheck() {
            this.loading = true;
            this.$v.searchForm.$reset()
            this.$v.addForm.$reset()
            setTimeout(() => {
                this.loading = false
            }, 1000)

        },
        checkedUser(){
            this.loading = true;
            setTimeout(() => {
                this.loading = false
            }, 1000)
        }
    },
    computed:{
        computedArray(){
            return this.addForm.contactsArray.map((item, index) => {

                let phone = item.phone ? item.phone.replace(/(\++)|([(]|[)])|(-)|(\s)/g,'') : ''

                if(phone.length < 12) {
                    this.addForm.contactsArray[index].check = false
                    this.addForm.contactsArray[index].checkPhoneBeforeSend = true
                    return
                }

                if(phone.length === 12 && !item.check) {
                    this.checkUser(phone, index)
                }

                return phone

            })
        },

        user(){
            return this.$store.getters.getUserData
        }
    },
    methods: {

        handleAddImage(e) {
            let self = this;
            let files = e.target.files;
            self.images = [];

            for (let key in files) {

                if (!files[key].type) return;

                if (!files[key].type.includes("image/")) {
                    alert(`Файл должен быть изображением: ${files[key].name}. Файлы других форматов отправлены не будут.`);
                    return;
                }

                if (e.target.files[key] instanceof File) {
                    self.images.push(e.target.files[key]);
                }


            }
        },
        handleClose(){
          this.checkedUser = null
        },
        b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;

            let byteCharacters = atob(b64Data);
            let byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                let slice = byteCharacters.slice(offset, offset + sliceSize);

                let byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                let byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }

            return new Blob(byteArrays, {type: contentType});
        },
        setPhone(phone){

            let val = phone ? phone.replace(/(\++)|([(]|[)])|(-)|(\s)/g,'') : ''

            this.searchForm.phone = this.selectedSearchPhone = val
        },
        searchFormSumbit(){

            let phone = this.searchForm.phone ? this.searchForm.phone.replace(/(\++)|([(]|[)])|(-)|(\s)/g,'') : '';


            let url = `/blacklist/search?contact=${phone}`;


            this.$v.searchForm.$touch();
            if (this.$v.searchForm.$invalid) {
                return false;
            }


            axios.get(url)
                .then(response =>{
                    response = response.data

                    if(response.success){
                        if(!response.data.length) {
                            this.checkedUser = false

                            this.searchArray = []
                            this.selectedSearchPhone = ''
                            this.searchForm = {
                                phone: ''
                            }

                            this.$v.searchForm.$reset()
                            return
                        }

                        this.checkedUser = response.data[0]


                        this.searchArray = []
                        this.selectedSearchPhone = ''
                        this.searchForm = {
                            phone: ''
                        }

                        this.$v.searchForm.$reset()

                    }

                })
                .catch(error => {
                    error = error.response.data
                })

        },
        searchBlackList(phone){

            if(phone.length < 8 || this.searchForm.phone === this.selectedSearchPhone) return

            let url = `/blacklist/search?contact=${phone}`;


            axios.get(url)
                .then(response =>{
                    response = response.data

                    if(response.success){
                        this.searchArray = response.data

                    }

                })
                .catch(error => {
                    error = error.response.data

                })

        },
        checkUser(phone, idx) {

            if(!this.user) return this.unauthorized = true

            let checkUrl = `/api/blacklist/check-contact`,
                params = {
                    type: 'phone',
                    contact: phone,
                }

            axios.post(checkUrl, params)
                .then(response => {
                    response = response.data

                    if(response.success){
                        this.addForm.contactsArray[idx].checkPhoneBeforeSend = true
                        this.addForm.contactsArray[idx].check = true
                    }

                })
                .catch(error=>{
                    error = error.response.data
                    if(!error.success){
                        this.addForm.contactsArray[idx].checkPhoneBeforeSend = false
                        this.addForm.contactsArray[idx].check = true
                    }

                })
        },

        addUser() {
            if(!this.user) return this.unauthorized = true
            let self = this,
                url = `/api/blacklist/store`;


            this.$v.addForm.$touch();
            if (this.$v.addForm.$invalid) {
                return false;
            }

            let data = new FormData();

            data.append('description', this.addForm.description);

            this.addForm.contactsArray.forEach((item, idx) => {

                let phone = item.phone.replace(/(\++)|([(]|[)])|(-)|(\s)/g,'')

                data.append(`contacts[${idx}][type]`, 'phone');
                data.append(`contacts[${idx}][contact]`, `${phone}`);

            })




            if(this.previewImagesOnlyBase64.length){
                this.previewImagesOnlyBase64.forEach(function (base64) {
                    let block = base64.split(";");
                    let contentType = block[0].split(":")[1];
                    let realData = block[1].split(",")[1];
                    let blob = self.b64toBlob(realData, contentType);
                    data.append('images[]', blob)
                });
            }

            axios.post(url, data, {
                header: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(response => {
                    response = response.data
                    if(response.success){


                        this.userAdded = true


                        setTimeout(() => {
                            this.addForm = {
                                contactsArray: [
                                    {
                                        phone: '',
                                        checkPhoneBeforeSend: true,
                                        check: false,
                                    }
                                ],
                                description: null,
                                images: [],
                            },
                            this.previewImagesOnlyBase64 = [],
                            this.previewImages = [],
                            this.images = [],

                            self.$v.addForm.$reset()

                            this.blackListCheck = true;
                            this.userAdded = null

                        }, 4000)


                    }
                })
                .catch(error => {
                    error = error.response.data
                    alert(error.message)
                })


        },
    },

}
</script>

<style lang="scss" scoped>
.black-list {


    &__content {
        background: #F0F1F5;
        padding: 32px 0 64px;


        &-wrap {
            width: 100%;
            margin: 0 auto;
            padding: 30px 31px 20px;
            max-width: 511px;
            background: #FFFFFF;
            box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1);
            border-radius: 5px;
        }

    }


    &__actions{
        justify-content: center;
        margin: 0 -5px;
        &-btn{
            font-weight: bold;
            font-size: 12px;
            line-height: 16px;
            padding: 10px 20px;
            border-radius: 45px;
            margin: 0 5px 10px;
        }
    }

    &__form {

        min-height: 250px;

        &-nav {
            width: 216px;
            margin: 0 auto 28px;
            background: #EAF1FC;
            border-radius: 45px;
            overflow: hidden;

            &-button {
                padding: 10px 20px;
                color: #2E76E4;
                font-weight: bold;
                font-size: 12px;
                line-height: 20px;
                background: transparent;
                box-shadow: none;
                border: none;
                border-radius: 45px;
                transition: opacity .2s ease;

                & + .black-list__form-nav-button {
                    margin-left: -10px;
                }

                &:hover {
                    opacity: .8;
                }

                &--active {
                    background: #2E76E4;
                    color: #fff;
                }

            }
        }

        &-wrap {
            position: relative;
            border-top: 1px solid #ECECEC;
            padding: 24px 22px 0;
        }

        &-submit {
            display: block;
            padding: 10px 20px;
            width: 135px;
            margin: 40px auto 0;
            font-weight: bold;
            font-size: 14px;
            line-height: 26px;
            color: #FFFFFF;
            border-radius: 45px;
            border: none;
            background: #2E76E4;
            box-shadow: none;
            transition: opacity .2s ease;

            &--width-auto{
                width: intrinsic;           /* Safari/WebKit используют нестандартное имя */
                width: -moz-max-content;    /* Firefox/Gecko */
                width: -webkit-max-content; /* Chrome */
                margin: 0 auto 20px;



            }


            &:hover {
                opacity: .8;
            }
        }

        &-loader {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: center;
            align-items: center;
            min-height: 250px;

        }
    }

    &__fieldset {
        &-legend {
            font-size: 24px;
            line-height: 32px;
            text-align: center;
            margin-bottom: 30px;
        }

        &-label {
            font-size: 14px;
            line-height: 22px;
            padding-left: 20px;
            margin-bottom: 5px;

            &-text {
                display: block;
                font-size: 14px;
                line-height: 22px;
                padding-left: 20px;
                margin-bottom: 5px;
            }

            &-file {
                margin: 0;
                width: 100%;

                &-wrap {
                    position: relative;
                    display: flex;
                    flex-flow: row nowrap;
                    justify-content: flex-start;
                    border: 1px solid #CED4DA;
                    border-radius: 3px;
                    overflow: hidden;
                    width: 100%;

                    input {
                        background: #FFFFFF;
                        color: #929292;
                        box-sizing: border-box;
                        font-size: 14px;
                        line-height: 22px;
                        padding: 9px 9px 9px 0;
                        width: 100%;

                        &:focus {
                            outline: none;
                            outline-offset: 0;
                        }
                    }

                    &:hover {
                        box-shadow: 0 0 5px rgba(46, 118, 228, 0.3);
                    }

                }

            }

            &-button {
                position: absolute;
                left: 0;
                top: 0;
                bottom: 0;
                display: flex;
                flex-flow: row nowrap;
                justify-content: center;
                align-items: center;
                padding: 10px 15px;
                font-weight: bold;
                font-size: 10px;
                color: #FFFFFF;
                background: #CED4DA;
                width: 140px;
                z-index: 1000;
                flex-shrink: 0;

                &::before {
                    display: block;
                    content: '';
                    width: 12px;
                    height: 12px;

                    background: url("/assets/images/file.svg") no-repeat center/contain;
                    margin-right: 5px;
                }
            }
        }

        &-input {
            padding: 10px 20px;
            font-size: 14px;
            line-height: 22px;
            margin-bottom: 0;
        }

        &-text-area {
            resize: none;
            padding: 10px 20px;
        }

        &-group {
            margin-bottom: 15px;

            &:last-child {
                margin-bottom: 0;
            }


            &--search{
                position: relative;
                margin-bottom: 0;
                padding-bottom: 25px;
                &>.field-error-text{
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    z-index: 0;
                    margin: 0;
                }

                .search{
                    position: absolute;
                    top: calc(100% - 25px);
                    width: 100%;
                    background: #fff;
                    box-shadow: 0px 2px 2px rgb(0 0 0 / 10%);
                    border-radius: 0 0 5px 5px;
                    z-index: 1;
                    text-align: left;
                    height: auto;
                    max-height: 250px;
                    overflow-y: auto;

                    .field-error-text{
                        margin: 0;
                        padding: 10px;
                    }

                    li{

                        span{
                            padding: 10px;
                            display: block;
                            background: transparent;
                            width: 100%;
                            color: #000;

                            &:last-child{
                                border-bottom: 1px solid #ECECEC;
                            }


                            &.search__label{
                                color: #2E76E4;
                                transition: background .2s ease;
                                &:hover{
                                    background: #ECECEC;
                                    cursor: pointer;
                                }
                            }



                        }

                        &:last-child{
                            span{
                                &:last-child{
                                    border-bottom: none;
                                }
                            }
                        }

                    }

                    &__item{
                        color: #2E76E4;
                        background: transparent;
                        font-size: 13px;
                        line-height: 1;


                    }

                }
            }
        }
    }
}

.LoaderBalls {
    width: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__item {
        // .LoaderBalls__wrapper__item
        $anim-drt: 0.4s;
        $anim-ease: cubic-bezier(.6, .05, .15, .95);
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #2E76E4;

        &:nth-child(1) {
            animation: bouncing $anim-drt alternate infinite $anim-ease;
        }

        &:nth-child(2) {
            animation: bouncing $anim-drt $anim-drt/4 alternate infinite $anim-ease backwards;
        }

        &:nth-child(3) {
            animation: bouncing $anim-drt $anim-drt/2 alternate infinite $anim-ease backwards;
        }
    }
}

@keyframes bouncing {

    0% {
        transform: translate3d(0, 10px, 0) scale(1.2, 0.85);
    }

    100% {
        transform: translate3d(0, -20px, 0) scale(0.9, 1.1);
    }
}

@media screen and (max-width: 992px) {
    .black-list__content-wrap {
        padding: 20px 21px 10px;
    }
}

@media screen and (max-width: 500px) {


    .black-list__fieldset-legend {
        font-size: 18px;
        line-height: 24px;
        margin-bottom: 20px;
    }
    .black-list__form-wrap {
        padding: 24px 0 0;

    }

    .black-list__fieldset-label-file-wrap input {
        font-size: 12px;
        line-height: 16px;
        padding: 9px 9px 9px 0;
    }

    .black-list__fieldset-label-button {
        width: 120px;
    }

    .black-list__actions{
        flex-wrap: wrap;
        justify-content: center;
    }
}

</style>
